export namespace Loans {
  export enum Pages {
    LOANS = 'loans',
  }
}
